<template>
    <el-dialog
        :model-value="visible"
        :width="width || '500px'"
        :center="false"
        :class="hideBorder ? 'common-dialog-con no-border' : 'common-dialog-con'"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :append-to-body="appendToBody"
        :before-close="() => {emit('on-close')}"
    >
        <template #header>
            <div class="title-con">
                <div class="title-txt" v-if="title">{{ title }}</div>
                <div v-if="showClose" class="close-btn" @click="() => {emit('on-close')}">
                    <i class="iconfont icon-a-guanbidanchuang"></i>
                </div>
            </div>
        </template>
        <slot></slot>
        <template #footer v-if="showFooter">
            <div class="dialog-footer">
               <el-button class="srt-el-button srt-el-button--cancel srt-el-button-h36" @click="cancel">取消</el-button>
               <el-button class="srt-el-button srt-el-button--primary srt-el-button-h36" @click="confirm">确定</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
    title: {
        type: String,
        default: ''
    },
    visible: {
        type: Boolean,
        default: false
    },
    width: {
        type: [Number, String],
        default: '500px'
    },
    type: {
        type: String,
        default: 'hahhah'
    },
    isNoPadding: {
        type: Boolean,
        default: false
    },
    showClose: {
        type: Boolean,
        default: true
    },
    hideBorder: {
       type: Boolean,
       default: false  
    },
    showFooter: {
       type: Boolean,
       default: false  
    },
    appendToBody: {
        type: Boolean,
        default: false 
    }
})
const emit = defineEmits(['on-close', 'on-confirm'])

const title = computed({
    get: () => {
        return props.title || ''
    },
    set: (val) => {
        return val
    }
})
const visible = computed({
    get: () => {
        return props.visible || false
    },
    set: (val) => {
        return val
    }
})

function cancel(){
    emit('on-close')
}

function confirm(){
    emit('on-confirm')
}

</script>

<style lang="scss" scoped>
.title-con {
    display: flex;
    align-items: center;
    position: relative;
    height: 100%;
    .iconfont {
        font-size: 24px;
        margin-right: 6px;
        &.info-icon {
            color: #FF9201;
        }
        &.error-icon {
            color: #FF4719;
        }
    }
    .title-icon-img {
        width: 24px;
        height: 24px;
        margin-right: 5px;
    }
    .title-txt {
        line-height: 54px;
        color: var(--color-black);
        font-size: 16px;
        font-weight: bold;
    }

    .close-btn {
        width: 54px;
        height: 54px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: absolute;
        right: -20px;
        .iconfont {
            color: var(--color-light-black);
            font-size: 12px;
        }
        &:hover {
            .iconfont {
                color: var(--color-primary)
            }
        }
    }
}

.dialog-footer {
    display: flex;
    justify-content: flex-end;
    border-top:1px solid#EFF0F2;
    padding: 20px 20px;
}
</style>
<style lang="scss">
.common-dialog-con {
    .el-dialog__header {
        height: 54px;
        padding: 0 20px;
        box-sizing: border-box;
        border-bottom: 1px solid var(--color-gray-auxiliary3);
        margin-right: 0;
    }
    &.no-border {
        .el-dialog__header {
            border-bottom: none !important;
        }
        .title-txt {
            position: relative;
            &::before {
                content: '';
                width: 4px;
                height: 15px;
                background: var(--srt-main-active-text-color);
                display: inline-block;
                margin-right: 8px;
                vertical-align: middle;
                transform: translateY(-1px);
            }
        }
    }
    .el-dialog__body {
        padding: 30px 20px 20px;
    }
    .el-dialog__headerbtn {
        top: 0px;
    }
    .el-dialog__footer {
        padding: 0px;
    }
}
</style>